<template>
	<div class="bg-white all margin-left padding-lr">
		<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" :rules="rules"
			ref="formLabelAlign">
			<el-form-item label="标题" prop="title">
				<input class="titmep height54 padding-lr-sm bge" v-model="formLabelAlign.title"
					placeholder="请用一段话，描述您的岗位标题..."></input>
			</el-form-item>
			<el-form-item label="描述" prop="content">
				<textarea class="txtmep padding-sm bge" v-model="formLabelAlign.content"
					placeholder="请描述岗位详情"></textarea>
			</el-form-item>
			<el-form-item label="工种类别" prop="category">
				<el-cascader :options="options" v-model="formLabelAlign.category" :props="props" clearable
					:show-all-levels="false">
				</el-cascader>
			</el-form-item>
			<el-form-item label="经验年限" prop="experience">
				<!-- 	<input class="titmep padding-lr-sm text-right height54" type="number" v-model="formLabelAlign.years"
					placeholder="请填写"></input> -->
				<div class="padding-lr-sm">
					<el-input type="years" v-model.number="formLabelAlign.experience" autocomplete="off"
						placeholder="请填写">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="薪资金额" prop="salary">
				<!-- <input class="titmep padding-lr-sm text-right height54" type="number" v-model="formLabelAlign.money"
					placeholder="可面议"></input> -->
				<div class="padding-lr-sm">
					<el-input type="years" v-model.number="formLabelAlign.salary" autocomplete="off" placeholder="可面议">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="结算方式" prop="settlement">
				<el-select v-model="formLabelAlign.settlement" placeholder="请选择">
					<el-option v-for="(item,index) in array" :key="index" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="工作位置" prop="area">
				<input class="titmep padding-lr-sm text-right height54" v-model="formLabelAlign.area"
					placeholder="可面议"></input>
			</el-form-item>
			<div @click="dialogVisible = true">
				<el-radio v-model="radio" label="1">发布招工信息即表示遵守 <span class="text-theme">《蓝友网招工信息发布规则》</span>
					，如果您违反规则可能导致您的账号异常 </el-radio>
			</div>
			<el-button type="primary" @click="submitForm()">立即创建</el-button>
			<p class="text-xs text-999">发布成功后，平台会在1个工作日内审核完成即可显示</p>
		</el-form>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span class="text-left" v-html="body"></span>
			<span slot="footer" class="dialog-footer pointer" @click="dialogVisible = false">
				确 定
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				labelPosition: 'left',
				category: [],
				dialogVisible: false,
				formLabelAlign: {
					title: '', //标题
					content: '', //描述
					experience: '', //经验年限
					salary: '', //薪资金额
					area: '', //工作位置
					settlement: '', //结算方式
					category: '', //工种类别
				},
				radio: "1",
				options: [], //工种类别列表
				props: {
					multiple: true,
					label: 'work_categroy_name',
					children: 'two',
					value: 'id'
				},
				array: [{
						name: '日结'
					},
					{
						name: '月结'
					},
					{
						name: '可面议'
					}
				], //结算方式
				// value: '',
				rules: {
					title: [{
						required: true,
						message: '请用一段话，描述您的岗位标题',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请描述岗位详情',
						trigger: 'blur'
					}],
					category: [{
						required: true,
						message: '请选择工种类别',
						trigger: 'change'
					}],
					experience: [{
							required: true,
							message: '请填写经验年限',
							trigger: 'blur'
						},
						{
							type: 'number',
							message: '经验年限必须为数字值'
						}
					],
					salary: [],
					settlement: [{
						required: true,
						message: '请选择活动区域',
						trigger: 'change'
					}]
				}, //表单校验规则
				longitude: 113.76927057974245,
				latitude: 34.76670519464811,
				id: 0, //修改的id
				addsecond: [],
				body: '', //蓝友网招工信息发布规则
			};
		},
		created() {
			this.getworkCategroy()
			this.getagreement()
			Bus.$on('edit', data => {
				this.id = data
				this.getworkCategroy()
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('edit')
		},
		methods: {
			handleClose(done) {

			},
			getagreement() {
				this.ajax('get', '/api/pc/agreement/getInfo', {
					type: 1,
				}, res => {
					// res = res.data
					if (res.status == 200) {
						this.body = res.data.content
					} else {
						this.$message.info(res.msg);
					}
				})
			},
			//立即创建
			submitForm() {
				let id = this.id
				console.log(id);
				this.$refs.formLabelAlign.validate((valid) => {
					if (valid) {
						if (id != 0) {
							this.subedit()
						} else {
							this.submit()
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getdetail() {
				this.ajax('get', '/api/pc/work/getMyWorkInfo', {
					id: this.id
				}, res => {
					this.formLabelAlign = {
						title: res.data.title,
						content: res.data.content,
						experience: Number(res.data.experience),
						settlement: res.data.settlement,
						salary: res.data.salary,
						area: res.data.area,
					}
					let addsecond = res.data.category
					let arr = []
					this.addsecond = addsecond
					if (addsecond.length > 0) {
						console.log('--*/*/*/', this.options, addsecond);
						this.options.map(ele => {
							ele.two.map(item => {
								addsecond.map(ala => {
									if (ala.id == item.id) {
										let info = [
											ele.id,
											ala.id
										]
										arr.push(info)

									}
								})
								console.log('*/*/*/', arr);
							})
						})
					}
					this.formLabelAlign.category = arr
					this.category = arr
				})
			},
			/**
			 * 获取用工分类
			 * */
			getworkCategroy() {
				this.ajax('get', '/api/pc/workCategroy/getlist', {
					type: 2
				}, res => {
					if (res.status == 200) {
						this.options = res.data
						console.log('addsecond', this.addsecond);
					}
				})
			},
			/**
			 * 提交
			 * */
			submit() {
				let arr = []
				this.formLabelAlign.category.map(item => {
					arr.push(item[1])
				})
				// return console.log(this.formLabelAlign.category)
				let model = this.$refs.formLabelAlign.model
				let info = {
					title: model.title,
					content: model.content,
					experience: model.experience,
					salary: model.salary ? model.salary : '面议',
					settlement: model.settlement,
					area: model.area,
					work_category_id: arr.join(','),
					lng: this.longitude,
					lat: this.latitude,
				}

				this.ajax('post', '/api/pc/work/publishWork', info, res => {
					console.log(res);
					this.$message(res.msg);
					if (res.status == 200) {

					} else {

					}
				})
			},
			/**
			 * 编辑修改
			 * */
			subedit() {
				let arr = []
				this.category.map(item => {
					arr.push(item[1])
				})
				let model = this.$refs.formLabelAlign.model
				let info = {
					title: model.title,
					content: model.content,
					experience: model.experience,
					salary: model.salary ? model.salary : '面议',
					settlement: model.settlement,
					area: model.area,
					work_category_id: arr.join(','),
					lng: this.longitude,
					lat: this.latitude,
					id: this.id
				}
				this.ajax('post', '/api/pc/work/editWork', info, res => {
					console.log(res);
					this.$message(res.msg);
					if (res.status == 200) {

					} else {

					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all {
		width: 921px;
		height: 878px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 40px;
	}

	.dialog-footer {
		width: 383px;
		height: 46px;
		background: #09827B;
		padding: 10px 32px;
		border-radius: 16px;
		color: #fff;
	}

	.titmep {
		width: 740px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}

	.bge {
		background: rgba(230, 230, 230, 0.3000);
	}

	.txtmep {
		width: 740px;
		height: 126px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}

	.height54 {
		height: 54px;
	}

	.el-form-item {
		margin-bottom: 19px;
	}

	.el-cascader,
	.el-select {
		width: 740px;
		height: 54px;
	}

	/deep/ .el-input>input {
		text-align: right;
		height: 54px;
	}

	/deep/ .el-button {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 60px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/release.vue